import { BDCore } from '@bizzdesign/sdk-knowledgegraph';
import {
  contextMenuShapeOptions,
  type GenericObject,
  mainButtonIcons,
  relationsIcons,
} from '@bizzdesign/modeler/models';
import { getElementType } from '@bizzdesign/modeler/utils-modeler';
import { getBDCoreObjectTypeIcon } from '@bizzdesign/shared/utils';

export function getElementIcon(element?: GenericObject): string {
  if (!element) return '';
  const type = getElementType(element);
  const { typeName, shapeType, promotion } = element;

  switch (type) {
    case 'shape': {
      const sType = shapeType || typeName;
      return (
        contextMenuShapeOptions.find((item) => item.id === sType)?.icon ?? ''
      );
    }

    case 'fromRepo':
    // TODO: handle more gracefully once getObjectTypeIcon can support BDCore icons
    case 'archiMate':
    case 'formalObject': {
      const elementType = typeName?.includes('Box')
        ? promotion?.typeName
        : typeName;
      const definition = Object.values(BDCore.objectDefinitions).find(
        (def) => def.key === `BDCore.${elementType}`,
      );
      return definition ? getBDCoreObjectTypeIcon(definition?.key) : '';
    }
    case 'line':
      return relationsIcons['TriggeringRelation'] ?? '';

    case 'relation': {
      const typeName = promotion?.typeName;
      if (typeName && typeName in relationsIcons) {
        return relationsIcons[typeName as keyof typeof relationsIcons] || '';
      }
      return '';
    }

    case 'text':
      return mainButtonIcons['createText'] ?? '';

    default:
      return '';
  }
}

export function getSelectedMenuItemDetailBasedOnSelectedElement(
  selectedElement?: GenericObject,
): string {
  if (!selectedElement) return '';

  const type = getElementType(selectedElement);

  switch (type) {
    case 'shape':
      return selectedElement['shapeType'];

    case 'archiMate':
      return selectedElement['promotion']?.['typeName'];

    case 'fromRepo':
      return selectedElement['promotion']?.['semanticsId'];

    case 'line': {
      const { sourceShapeType, targetShapeType } =
        selectedElement['customLinkEndShapeTypes'] ?? {};

      if (targetShapeType === 'none' && sourceShapeType === 'none') {
        return 'LineWithoutArrows';
      }
      return selectedElement['typeName'];
    }
    case 'relation': {
      return (
        selectedElement['promotion']?.['typeName'] ||
        selectedElement['typeName']
      );
    }

    case 'formalObject': {
      return selectedElement['typeName'];
    }

    default:
      return '';
  }
}
